export default "__VITE_ASSET__Bn20TovY__"